// tab 枚举
export enum TabEnum {
  video = 1 // 视频
}

// 登陆类型
export enum LoginTypeEum {
  REGISTER = 1, // 注册
  LOGIN = 2 // 登陆
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

/**
 * @description:  contentTyp
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8'
}

/**
 * 请求header
 * @description:  contentTyp
 */
export enum ConfigEnum {
  // TOKEN
  TOKEN = 'X-Access-Token'
}

// 1. 瀑布流 2. 分类 3. 标签
export enum CategoryEnum {
  waterfall = 1, // 瀑布流
  category = 2, // 分类
  tag = 3 // 标签
}

// 定义公告类型的枚举
export enum AnnouncementTypeEnum {
  Marquee = 1, // 跑马灯
  TextPopu = 2, // 文字弹窗
  PopupAnnouncement = 3 // 弹窗公告
}

// 枚举定义广告类型
export enum AdvTypeEnum {
  START_ADV = 'START_ADV', // 启动广告
  SPONSOR_ADV = 'SPONSOR_ADV', // 赞助广告
  LEVITATE_ADV = 'LEVITATE_ADV', // 悬浮广告
  LOGO_ADV = 'LOGO_ADV', // LOGO广告
  SIDEBAR_ADV = 'SIDEBAR_ADV', // 侧边栏广告
  LIST_ADV = 'LIST_ADV', // 列表广告
  PLAY_ADV = 'PLAY_ADV', // 播放页广告
  PAGE_ADV = 'PAGE_ADV', // 广告页
  MY_PAGE_ADV = 'MY_PAGE_ADV', // 我的页面广告
  ICON_ADV = 'ICON_ADV', // ICON广告
  TOP_ADV = 'TOP_ADV', // 头部广告
  WORD = 'WORD' // 文字广告
}

// 枚举定义位置类型
export enum PositionTypeEnum {
  TOP = 'TOP', // 顶部区域
  BANNER = 'BANNER', // 条幅区域
  SPACING = 'SPACING', // 影片间隔区域
  PLAY = 'PLAY', // 播放广告区域
  BOTTOM = 'BOTTOM', // 底部区域
  WORD = 'WORD', // 文字区域
  DOWN = 'DOWN' // 播放器下方广告位
}

// 枚举定义广告横幅类型
export enum BannerTypeEnum {
  BANNER = 'BANNER', // 横幅广告
  CLUSTER = 'CLUSTER', // 集群广告
  WORD = 'WORD', // 文字广告
  PRE_ROLL = 'PRE_ROLL',
  PAUSE = 'PAUSE' // 暂停广告
}

// 手机验证码类型
export enum VfcTypeEnum {
  REGISTER = 1,
  LOGIN = 2,
  BINDPHONE = 3,
  RESETPWD = 4,
  FORGOTPWD = 5
}

// 影片间隔类型: 1.6个；2.10个；3.12个; 4.20个；
export enum SpaceEnum {
  SPACE_1 = 6, // 1.6个
  SPACE_2 = 10, // 10个
  SPACE_3 = 12, // 12个
  SPACE_4 = 20 // 20个
}

export enum DPlayerEvents {
  abort = 'abort',
  canplay = 'canplay',
  canplaythrough = 'canplaythrough',
  durationchange = 'durationchange',
  emptied = 'emptied',
  ended = 'ended',
  error = 'error',
  loadeddata = 'loadeddata',
  loadedmetadata = 'loadedmetadata',
  loadstart = 'loadstart',
  mozaudioavailable = 'mozaudioavailable',
  pause = 'pause',
  play = 'play',
  playing = 'playing',
  progress = 'progress',
  ratechange = 'ratechange',
  seeked = 'seeked',
  seeking = 'seeking',
  stalled = 'stalled',
  suspend = 'suspend',
  timeupdate = 'timeupdate',
  volumechange = 'volumechange',
  waiting = 'waiting',
  screenshot = 'screenshot',
  thumbnails_show = 'thumbnails_show',
  thumbnails_hide = 'thumbnails_hide',
  danmaku_show = 'danmaku_show',
  danmaku_hide = 'danmaku_hide',
  danmaku_clear = 'danmaku_clear',
  danmaku_loaded = 'danmaku_loaded',
  danmaku_send = 'danmaku_send',
  danmaku_opacity = 'danmaku_opacity',
  contextmenu_show = 'contextmenu_show',
  contextmenu_hide = 'contextmenu_hide',
  notice_show = 'notice_show',
  notice_hide = 'notice_hide',
  quality_start = 'quality_start',
  quality_end = 'quality_end',
  destroy = 'destroy',
  resize = 'resize',
  fullscreen = 'fullscreen',
  fullscreen_cancel = 'fullscreen_cancel',
  subtitle_show = 'subtitle_show',
  subtitle_hide = 'subtitle_hide',
  subtitle_change = 'subtitle_change'
}
